/*eslint complexity: ["error", 28]*/
import React from 'react';
import { Form, Tab, Tabs } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import {
  CreateUpdateCardDto,
  GetExamDto,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import momencik from '../../../common/momencik';
import { SupportingExaminationView } from '../../containers/SupportingExaminationView/SupportingExaminationView';
import { SupportingType } from '../../../common/spdCore/validation/schemas';
import { FormControlTextarea3 } from '../../../app/components/FormControlTextarea';
import { ChooseSigned } from '../Users/ChooseSigned';
import { Role } from '../../../common/spdCore/authorization/roles';

import { CardStatusFields } from './CardStatusFields';

interface CardSanitaryEditorProps {
  exam: GetExamDto;
  card: CreateUpdateCardDto;
  id: string | undefined;
  propertyChange: (obj: Partial<CreateUpdateCardDto>) => void;
  onSupportChange?: () => void;
}

export const CardSanitaryEditor: React.FC<CardSanitaryEditorProps> = ({
  exam,
  card,
  id,
  propertyChange,
  onSupportChange,
}) => {
  return (
    <>
      <Tabs defaultActiveKey="data" id="data" className="mb-2">
        <Tab eventKey="data" title="Dane podstawowe" className="mb-2">
          <div className="d-grid gap-3">
            <FormRow controlId="pass" label="Wynik pozytywny">
              <Form.Check
                type="checkbox"
                defaultChecked={
                  card?.pass || card?.pass === undefined || card?.pass === null
                    ? true
                    : false
                }
                onChange={e => propertyChange({ pass: e.target.checked })}
              />
            </FormRow>
            <FormRow controlId="staff" label="Lekarz">
              <ChooseSigned
                userUID={card?.psychologistUID}
                handleOnChange={user =>
                  propertyChange({
                    psychologistUID: user?.uid,
                  })
                }
                roles={[Role.MedicalAssessor, Role.MedicalSpecialist]}
              />
            </FormRow>
            <FormRow controlId="number" label="Numer">
              <Form.Control
                type="text"
                disabled={
                  card?.cardDate && card.cardDate.getFullYear() > 2024
                    ? true
                    : false
                }
                value={
                  id || (card?.cardDate && card.cardDate.getFullYear() <= 2024)
                    ? card?.number || ''
                    : '-- Numer zostanie nadany automatycznie po zapisie --'
                }
                onChange={e =>
                  propertyChange({
                    number: e.target.value,
                  })
                }
              />
            </FormRow>
            <FormRow controlId="cardDate" label="Data karty">
              <Form.Control
                type="date"
                name="datepic"
                required={false}
                placeholder="DateRange"
                value={momencik(card?.cardDate, 'YYYY-MM-DD')}
                onChange={e =>
                  propertyChange({
                    cardDate: e.target.value ? new Date(e.target.value) : null,
                  })
                }
              />
            </FormRow>
            <FormRow controlId="postDate" label="Data wysłania">
              <Form.Control
                type="date"
                name="datepic"
                placeholder="DateRange"
                value={momencik(card?.postDate, 'YYYY-MM-DD')}
                onChange={e =>
                  propertyChange({ postDate: new Date(e.target.value) })
                }
              />
            </FormRow>
            <FormRow controlId="nextExamDate" label="Data następnego badania">
              <Form.Control
                type="date"
                name="datepic"
                placeholder="DateRange"
                value={momencik(card?.nextExamDate, 'YYYY-MM-DD')}
                onChange={e =>
                  propertyChange({
                    nextExamDate: e.target.value
                      ? new Date(e.target.value)
                      : null,
                  })
                }
              />
            </FormRow>
            <FormRow controlId="conclusions" label="Orzeczenia">
              <FormControlTextarea3
                defaultValue={card?.conclusions || ''}
                onChange={e => propertyChange({ conclusions: e.target.value })}
              />
            </FormRow>
            <FormRow controlId="interview" label="Wywiad">
              <FormControlTextarea3
                defaultValue={card?.interview || ''}
                onChange={e => propertyChange({ interview: e.target.value })}
              />
            </FormRow>
            <CardStatusFields
              verified={card?.verified}
              withoutSign={card?.withoutSign}
              propertyChange={propertyChange}
            />
          </div>
        </Tab>
        <Tab eventKey="helpExam" title="Badania pomocnicze">
          <SupportingExaminationView
            examId={exam.id}
            mode={SupportingType.helpExam}
            cardId={id}
            doctorUid={card.psychologistUID || undefined}
            onSupportChange={onSupportChange}
          />
        </Tab>
        <Tab
          eventKey="specialisedConsultations"
          title="Konsultacje specjalistyczne"
        >
          <SupportingExaminationView
            examId={exam.id}
            mode={SupportingType.specialisedConsultation}
            cardId={id}
            doctorUid={card.psychologistUID || undefined}
            onSupportChange={onSupportChange}
          />
        </Tab>
      </Tabs>
    </>
  );
};
